App.filter('healthInsuranceVariantToNumberFilter', function () {
    var dictionary = {
        'SINGLE': 1,
        'PARTNER': 2,
        'FAMILY': 3,
    };

    return function (el) {
        if (!el) {
            return el;
        }

        return dictionary[el] || el;
    };
});
